export function toServiceLink() {
  const url = "https://www.fujikawa-h.net/"
  window.open(url, "_blank")
}
